// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hbWh","importantInfo":"styles_importantInfo__3XGi6"};